import { Grid } from '@mui/material';
import Image from 'components/medias/Image';
import error from 'assets/images/illustrations/error.svg';
import { FormattedMessage } from 'react-intl';
import { FilledButton } from 'components';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  container: {
    left: '50%',
    position: 'absolute',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    width: '80%',
  },
  errorContainer: {
    textAlign: 'center',
  },
  title: {
    fontSize: '3em',
    fontWeight: 'bold',
    padding: 50,
  },
}), { name: 'ErrorPage' });

const ErrorPage = (): JSX.Element => {
  const classes = useStyles();

  return (
    <Grid className={classes.container} container>
      <Grid className={classes.errorContainer} item xs={12}>
        <div className={classes.title}>
          <FormattedMessage id="error_page.title" />
        </div>

        <FilledButton color="violet" onClick={() => window.location.reload()}>
          <FormattedMessage id="button.reloadPage" />
        </FilledButton>
      </Grid>

      <Grid item xs={4} />
      <Grid item xs={4}>
        <Image src={error} />
      </Grid>
      <Grid item xs={4} />
    </Grid>
  );
};

export default ErrorPage;
